var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLike12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#777",
  strokeLinejoin: "round",
  d: "M3 2.648v8.528h6a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5H6.2a4.8 4.8 0 0 0-.695-2.559C4.748.61 3.005.83 3.005.83zM3 4.178H.5v7H3z"
})));
export default SvgIconLike12;